import { render } from "./StafetDonationFlow.vue?vue&type=template&id=607976d8"
import script from "./StafetDonationFlow.vue?vue&type=script&lang=js"
export * from "./StafetDonationFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__